import { useState, useEffect } from 'react';
import SkuService from './stockService';
import stockService from './stockService';

const useManageStock = () => {
  const [skus, setSku] = useState([])
  const [stockBalance, setStockBalance] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const addStockData = async (formData) => {
    console.log(formData)
    let result = true
    setIsLoading(true);
    try {
        const response = await stockService.addStockData(formData);
        console.log(response)
    } catch (err) {
        console.log(err.response.data.message || 'An error occurred.');
        result = err.response.data.message
    } finally {
      setIsLoading(false);
    }
    return result
  };

  const confirmMonthlyStock = async (yearMonth) => {
    console.log(yearMonth)
    let result = true
    setIsLoading(true);
    try {
        const response = await stockService.confirmMonthlyStock(yearMonth);
        console.log(response)
    } catch (err) {
        console.log(err.response.data.message || 'An error occurred.');
        result = err.response.data.message
    } finally {
      setIsLoading(false);
    }
    return result
  };

  const getStockBalance = async () => {
    setIsLoading(true);
    try {
      const response = await stockService.getStockBalance();
      setStockBalance(response.data.data);
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
  };

  return { 
    addStockData,
    confirmMonthlyStock,
    getStockBalance,
    stockBalance,
    isLoading,
    error
  };
}

export default useManageStock;
